import React from "react"
import useScript from "./usescript"

function Sleeperoo(props) {
  useScript("https://api.sleeperoo.de/index.php?option=com_bim&view=affiliate&id=47")
  return <div id="bim_affiliate_container" />
}
export default Sleeperoo
